import { FormControl, FormLabel, Textarea } from '@mui/joy'
import React from 'react'

function EmpfehlungEditor({ empfehlung, setempfehlung }) {
  return (
    <FormControl>
      <FormLabel>Empfehlung</FormLabel>
      <Textarea
        minRows={8}
        value={empfehlung}
        placeholder="Empfehlung..."
        variant="outlined"
        onChange={(e) => setempfehlung(e.target.value)}
      />
    </FormControl>
  )
}

export default EmpfehlungEditor
